import { Component, Input } from '@angular/core';
import { ECardType } from './typing';

@Component({
  selector: 'm-functional-card-icon',
  template: `
    <ng-container [ngSwitch]="mType">
      <i nz-icon *ngSwitchCase="ECardType.application">
        <svg
          width="42px"
          height="37px"
          viewBox="0 0 42 37"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <linearGradient x1="-5.29806635%" y1="-7.1734601%" x2="50%" y2="88.8038549%" id="linearGradient-1">
              <stop stop-color="#FAC400" offset="0%"></stop>
              <stop stop-color="#F39200" offset="100%"></stop>
            </linearGradient>
          </defs>
          <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="应用层" transform="translate(-246.000000, -72.000000)">
              <g id="编组" transform="translate(224.000000, 72.000000)">
                <g id="编组-4" transform="translate(22.000000, 0.000000)">
                  <path
                    d="M0,0 L42,0 L42,25.5858435 C42,26.3527884 41.5614214,27.0521885 40.8710322,27.3862054 L21.8710322,36.5785863 C21.3208484,36.8447705 20.6791516,36.8447705 20.1289678,36.5785863 L1.12896778,27.3862054 C0.438578587,27.0521885 -3.50165546e-16,26.3527884 0,25.5858435 L0,0 L0,0 Z"
                    id="矩形"
                    fill="url(#linearGradient-1)"
                  ></path>
                  <text id="应用层" font-family="PingFangSC-Regular, PingFang SC" font-size="12" font-weight="normal" fill="#FFFFFF">
                    <tspan x="3" y="19">应用层</tspan>
                  </text>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </i>
      <i nz-icon *ngSwitchCase="ECardType.configuration">
        <svg
          width="42px"
          height="37px"
          viewBox="0 0 42 37"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <linearGradient x1="7.32854974%" y1="16.8664093%" x2="76.515997%" y2="73.064369%" id="linearGradient-2">
              <stop stop-color="#78BAFF" offset="0%"></stop>
              <stop stop-color="#3376ED" offset="100%"></stop>
            </linearGradient>
          </defs>
          <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="配置层" transform="translate(-548.000000, -72.000000)">
              <g id="编组" transform="translate(224.000000, 72.000000)">
                <g id="卡片" transform="translate(302.000000, 0.000000)">
                  <g id="编组-4" transform="translate(22.000000, 0.000000)">
                    <path
                      d="M0,0 L42,0 L42,25.5858435 C42,26.3527884 41.5614214,27.0521885 40.8710322,27.3862054 L21.8710322,36.5785863 C21.3208484,36.8447705 20.6791516,36.8447705 20.1289678,36.5785863 L1.12896778,27.3862054 C0.438578587,27.0521885 -3.50165546e-16,26.3527884 0,25.5858435 L0,0 L0,0 Z"
                      id="矩形"
                      fill="url(#linearGradient-2)"
                    ></path>
                    <text id="配置层" font-family="PingFangSC-Regular, PingFang SC" font-size="12" font-weight="normal" fill="#FFFFFF">
                      <tspan x="3" y="19">配置层</tspan>
                    </text>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </i>
    </ng-container>
  `
})
export class MFunctionalCardIconComponent {
  @Input() mType!: ECardType;

  ECardType = ECardType;
}
